/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'data-grid';
const componentName = 'avi-diff-grid';
const prefix = `${moduleName}.${componentName}`;

export const defaultEmptyListPlaceholderMessage = `${prefix}.defaultEmptyListPlaceholderMessage`;

export const ENGLISH = {
    [defaultEmptyListPlaceholderMessage]: 'No diff data.',
};
